(function () {

  /**
   * Converts a Shopify variant option name to a slug.
   * e.g. "Lion's Mane"      → "lions-mane"
   *      "Lemongrass Pandan" → "lemongrass-pandan"
   *      "Passion Fruit"     → "passion-fruit"
   */
  function toSlug(name) {
    return name
      .toLowerCase()
      .replace(/[''']/g, '')         // strip apostrophes
      .replace(/[^a-z0-9]+/g, '-')  // non-alphanumeric runs → hyphen
      .replace(/^-|-$/g, '');        // trim leading/trailing hyphens
  }

  /**
   * Reads all variant option names from the page.
   * Works for both dropdown (select) and swatch (radio) styles.
   */
  function getAllVariantNames() {
    var select = document.querySelector('variant-selects select');
    if (select) {
      return Array.from(select.options).map(function (o) { return o.value; });
    }
    return Array.from(
      document.querySelectorAll('variant-selects input[type="radio"]')
    ).map(function (r) { return r.value; });
  }

  function getSelectedVariantName() {
    var select = document.querySelector('variant-selects select');
    if (select) return select.value;
    var checked = document.querySelector('variant-selects input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  /**
   * Build a set of slugs that actually have images in this gallery.
   * Any image whose alt text does NOT match a known variant slug
   * is treated as a shared/generic image and always stays visible.
   */
  function buildKnownVariantSlugs(allVariantNames) {
    var slugSet = new Set(allVariantNames.map(toSlug));
    var found = new Set();
    document.querySelectorAll(
      'li.product__media-item img, li.thumbnail-list__item img'
    ).forEach(function (img) {
      if (slugSet.has(img.alt)) found.add(img.alt);
    });
    return found;
  }

  function filterImages(variantName, knownVariantSlugs) {
    var targetSlug = toSlug(variantName);

    // Safety fallback: if no images found for this variant, show everything
    var hasImages = Array.from(
      document.querySelectorAll('li.product__media-item img')
    ).some(function (img) { return img.alt === targetSlug; });

    if (!hasImages) {
      document.querySelectorAll(
        'li.product__media-item, li.thumbnail-list__item'
      ).forEach(function (item) { item.style.display = ''; });
      refreshCounter();
      return;
    }

    // Filter main gallery slides
    document.querySelectorAll('li.product__media-item').forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      var isVariantSpecific = knownVariantSlugs.has(img.alt);
      item.style.display = (!isVariantSpecific || img.alt === targetSlug) ? '' : 'none';
    });

    // Filter thumbnail strip
    document.querySelectorAll('li.thumbnail-list__item').forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      var isVariantSpecific = knownVariantSlugs.has(img.alt);
      item.style.display = (!isVariantSpecific || img.alt === targetSlug) ? '' : 'none';
    });

    refreshCounter();

  }

  // Tells Dawn's slider to recalculate the counter total
  // based on currently visible slides
  function refreshCounter() {
    var sliderComp = document.querySelector('media-gallery slider-component');
    if (sliderComp && typeof sliderComp.initPages === 'function') {
      sliderComp.initPages();
    }
  }

  function init() {
    var allVariantNames   = getAllVariantNames();
    var knownVariantSlugs = buildKnownVariantSlugs(allVariantNames);
    var selected          = getSelectedVariantName();
    if (selected) filterImages(selected, knownVariantSlugs);

    // Dawn: dropdown select change
    var select = document.querySelector('variant-selects select');
    if (select) {
      select.addEventListener('change', function () {
        filterImages(select.value, knownVariantSlugs);
      });
    }

    // Dawn: radio/swatch change
    document.querySelectorAll('variant-selects input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) filterImages(radio.value, knownVariantSlugs);
      });
    });

    // Dawn: variant:change custom event (some versions)
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (v) filterImages(v.option1 || v.public_title || v.title, knownVariantSlugs);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();